import {observer} from "mobx-react";
import {OrganizationPanel} from "../../OrganizationPanel";
import {ServiceTypePanel} from "../../ServiceTypePanel";
import {BankDataPanel} from "../../BankDataPanel";
import {DeliveryInfoPanel} from "../../delivery/DeliveryInfoPanel";
import {DocumentPanel} from "../../document/DocumentPanel";
import {InsurancePanel} from "../../InsurancePanel";
import {HolderPanel} from "../../holder/HolderPanel";
import {VehiclePanelNz} from "./VehiclePanelNz";
import {DesignatedRegistrationDatePanel} from "../../DesignatedRegistrationDatePanel";
import {featureStore, registrationStore} from "../../../../../../store";
import {AffiliatePanel} from "../../AffiliatePanel";

const DetailNz = observer(function DetailNz() {
    return <div className="columns">
        <div className="column is-half">
            <div className="columns">
                <div className={featureStore.isActive('DESIGNATED_REGISTRATION_DATE') && registrationStore.isCorporate?
                    "column is-one-third" : "column is-half"}>
                    <ServiceTypePanel/>
                </div>
                {featureStore.isActive('DESIGNATED_REGISTRATION_DATE') && registrationStore.isCorporate &&
                <div className="column is-one-third">
                    <DesignatedRegistrationDatePanel/>
                </div>
                }
                <div className={featureStore.isActive('DESIGNATED_REGISTRATION_DATE') && registrationStore.isCorporate?
                    "column is-one-third" : "column is-half"}>
                    <OrganizationPanel/>
                </div>
            </div>

            <HolderPanel />
            <BankDataPanel />
            <div className="columns">
                <div className="column is-half">
                    <InsurancePanel />
                </div>
                <div className="column is-half">
                    <AffiliatePanel />
                </div>
            </div>
        </div>
        <div className="column is-half">
            <VehiclePanelNz />
            <DeliveryInfoPanel />
            <DocumentPanel />
        </div>
    </div>
})

export {
    DetailNz
}
